import React from "react";
import { Link } from "gatsby";
import { checkSlugForPrefixSlash } from "./HelperFunctions";

const BlogArticleLink = ({ to, className, children }) => (
  <Link to={checkSlugForPrefixSlash(to)} className={className}>
    {children}
  </Link>
);

export default BlogArticleLink;
